module.exports = __webpack_public_path__ + "740ef4bf1d15794bfbeb7a4ee804a760.svg";